/* helper function definitions */
import { PropsWithChildren } from 'react';

/* plugin exports  */
export * from './StyleInjection';
export * from './Theme';
export * from './Apollo';
export * from './Workspace';
export * from './initialize';

/**
 * https://dhanrajsp.me/snippets/using-context-with-hoc
 * Utility function to compose a HOC by wrapping it with multiple context providers.
 * @param providers - Array of React components serving as context providers.
 * @returns Function that takes a base component and returns a component wrapped with the given context providers.
 * @example
 * const EnhancedComponent = withContextProviders([Provider1, Provider2])(BaseComponent);
 */
export const withContextProviders =
	(providers: React.ComponentType<PropsWithChildren>[]) =>
	(Component: React.ComponentType): React.FC<PropsWithChildren> =>
	(props: PropsWithChildren<JSX.IntrinsicAttributes>) => {
		return providers.reduceRight(
			(acc, Provider) => {
				return <Provider>{acc}</Provider>;
			},
			<Component {...props} />,
		);
	};
